import PhysicalRiskAssessmentForm
  from "../SupplierPhysicalRiskQuestionnaire/components/PhysicalRiskAssessmentForm/PhysicalRiskAssessmentForm";
import { t } from "i18next";

export const colors = [
  {
    value: 3,
    color: "hsl(147,100%,35%)",
    legendText: t("physicalRisk.riskLevels.low"),
    legendTextColor: "white",
  },
  {
    value: 2,
    color: "hsl(24,84%,42%)",
    legendText: t("physicalRisk.riskLevels.medium"),
    legendTextColor: "white",
  },
  {
    value: 1,
    color: "hsl(0,100%,50%)",
    legendText: t("physicalRisk.riskLevels.high"),
    legendTextColor: "white",
  },
];

export const colorsForGreggs = [
  {
    value: 1,
    color: "hsl(147,100%,35%)",
    legendText: t("physicalRisk.riskLevels.veryLowToLow"),
    legendTextColor: "white",
  },
  {
    value: 2,
    color: "hsl(22, 86%, 91%)",
    legendText: t("physicalRisk.riskLevels.lowToMedium"),
    legendTextColor: "hsl(0,0%,30%)",
  },
  {
    value: 3,
    color: "hsl(45, 100%, 50%)",
    legendText: t("physicalRisk.riskLevels.medium"),
    legendTextColor: "black",
  },
  {
    value: 4,
    color: "hsl(0,100%,50%)",
    legendText: t("physicalRisk.riskLevels.high"),
    legendTextColor: "white",
  },
];

export const colorsForMenzies = [
  {
    value: 1,
    color: "hsl(147,100%,35%)",
    legendText: t("physicalRisk.riskLevels.low"),
    legendTextColor: "white",
  },
  {
    value: 2,
    color: "hsl(24,84%,42%)",
    legendText: t("physicalRisk.riskLevels.medium"),
    legendTextColor: "white",
  },
  {
    value: 3,
    color: "hsl(0,100%,50%)",
    legendText: t("physicalRisk.riskLevels.high"),
    legendTextColor: "white",
  },
];

export function mapLocationsModalData(data) {
  return data.map(el => {
    return {
      id: el.id,
      name: el.location,
      data: el,
      component: PhysicalRiskAssessmentForm,
      customTabListTitle: el.supplierName,
      customTabListSubTitle: el.location,
      customTabPanelTitle: `${el.supplierName}: ${el.location}`
    };
  });
}

export const suppliersRiskHeaders = [
  {
    label: t("physicalRisk.suppliersSection.headers.supplierName"),
    attribute: "supplierName"
  },
  {
    label: t("physicalRisk.suppliersSection.headers.country"),
    attribute: "country"
  },
  {
    label: t("physicalRisk.suppliersSection.headers.floodingRiskRating"),
    attribute: "floodingRiskRating"
  },
  {
    label: t("physicalRisk.suppliersSection.headers.droughtRiskRating"),
    attribute: "droughtRiskRating"
  },
  {
    label: t("physicalRisk.suppliersSection.headers.heatWaveRiskRating"),
    attribute: "heatWaveRiskRating"
  },
  {
    label: t("physicalRisk.suppliersSection.headers.seaLevelRiseRiskRating"),
    attribute: "seaLevelRiseRiskRating"
  },
  {
    label: t("physicalRisk.suppliersSection.headers.coastalFloodingRiskRating"),
    attribute: "coastalFloodingRiskRating"
  },
  {
    label: t("physicalRisk.suppliersSection.headers.overallRiskRating"),
    attribute: "overallRiskRating"
  }
];

export const ownAssetsHeaders = [
  {
    label: t("physicalRisk.ownAssetsSection.headers.location"),
    attribute: "location"
  },
  {
    label: t("physicalRisk.ownAssetsSection.headers.floodingRiskRating"),
    attribute: "floodingRiskRating"
  },
  {
    label: t("physicalRisk.ownAssetsSection.headers.droughtRiskRating"),
    attribute: "droughtRiskRating"
  },
  {
    label: t("physicalRisk.ownAssetsSection.headers.heatWaveRiskRating"),
    attribute: "heatWaveRiskRating"
  },
  {
    label: t("physicalRisk.ownAssetsSection.headers.seaLevelRiseRiskRating"),
    attribute: "seaLevelRiseRiskRating"
  },
  {
    label: t("physicalRisk.ownAssetsSection.headers.coastalFloodingRiskRating"),
    attribute: "coastalFloodingRiskRating"
  },
  {
    label: t("physicalRisk.ownAssetsSection.headers.overallRiskRating"),
    attribute: "overallRiskRating"
  }
];

export const depotsHeaders = [
  {
    label: t("physicalRisk.depotsSection.headers.depot"),
    attribute: "depot"
  },
  {
    label: t("physicalRisk.depotsSection.headers.coastalFloodingRiskRating"),
    attribute: "coastalFloodingRiskRating"
  },
  {
    label: t("physicalRisk.depotsSection.headers.seaLevelRiseRiskRating"),
    attribute: "seaLevelRiseRiskRating"
  },
  {
    label: t("physicalRisk.depotsSection.headers.heatStressRiskRating"),
    attribute: "heatStressRiskRating"
  },
  {
    label: t("physicalRisk.depotsSection.headers.floodingRiskRating"),
    attribute: "floodingRiskRating"
  },
  {
    label: t("physicalRisk.depotsSection.headers.overallRiskRating"),
    attribute: "overallRiskRating"
  }
];

export const supplyRiskHeaders = [
  {
    label: t("physicalRisk.supplyRiskSection.headers.location"),
    attribute: "location"
  },
  {
    label: t("physicalRisk.supplyRiskSection.headers.seaLevelRiseModerate"),
    attribute: "seaLevelRiseModerate"
  },
  {
    label: t("physicalRisk.supplyRiskSection.headers.seaLevelRiseHigh"),
    attribute: "seaLevelRiseHigh"
  },
  {
    label: t("physicalRisk.supplyRiskSection.headers.coastalFloodingModerate"),
    attribute: "coastalFloodingModerate"
  },
  {
    label: t("physicalRisk.supplyRiskSection.headers.coastalFloodingHigh"),
    attribute: "coastalFloodingHigh"
  },
  {
    label: t("physicalRisk.supplyRiskSection.headers.riverineFloodingModerate"),
    attribute: "riverineFloodingModerate"
  },
  {
    label: t("physicalRisk.supplyRiskSection.headers.riverineFloodingHigh"),
    attribute: "riverineFloodingHigh"
  },
  {
    label: t("physicalRisk.supplyRiskSection.headers.extremeHeatShorttermLowModerate"),
    attribute: "extremeHeatShorttermLowModerate"
  },
  {
    label: t("physicalRisk.supplyRiskSection.headers.extremeHeatshorttermHigh"),
    attribute: "extremeHeatshorttermHigh"
  },
  {
    label: t("physicalRisk.supplyRiskSection.headers.longtermSurfaceFlooding"),
    attribute: "longtermSurfaceFlooding"
  },
  {
    label: t("physicalRisk.supplyRiskSection.headers.overallRiskRating"),
    attribute: "overallRisk"
  }
];

export const storesRiskHeaders = [
  {
    label: t("physicalRisk.storesRiskSection.headers.location"),
    attribute: "location"
  },
  {
    label: t("physicalRisk.storesRiskSection.headers.seaLevelRiseModerate"),
    attribute: "seaLevelRiseModerate"
  },
  {
    label: t("physicalRisk.storesRiskSection.headers.seaLevelRiseHigh"),
    attribute: "seaLevelRiseHigh"
  },
  {
    label: t("physicalRisk.storesRiskSection.headers.coastalFloodingModerate"),
    attribute: "coastalFloodingModerate"
  },
  {
    label: t("physicalRisk.storesRiskSection.headers.coastalFloodingHigh"),
    attribute: "coastalFloodingHigh"
  },
  {
    label: t("physicalRisk.storesRiskSection.headers.riverineFloodingModerate"),
    attribute: "riverineFloodingModerate"
  },
  {
    label: t("physicalRisk.storesRiskSection.headers.riverineFloodingHigh"),
    attribute: "riverineFloodingHigh"
  },
  {
    label: t("physicalRisk.storesRiskSection.headers.extremeHeatShorttermLowModerate"),
    attribute: "extremeHeatShorttermLowModerate"
  },
  {
    label: t("physicalRisk.storesRiskSection.headers.extremeHeatshorttermHigh"),
    attribute: "extremeHeatshorttermHigh"
  },
  {
    label: t("physicalRisk.storesRiskSection.headers.longtermSurfaceFlooding"),
    attribute: "longtermSurfaceFlooding"
  },
  {
    label: t("physicalRisk.storesRiskSection.headers.overallRiskRating"),
    attribute: "overallRisk"
  }
];
export const menziesHeaders = [
  {
    label: t("physicalRisk.menziesSection.headers.location"),
    attribute: "location"
  },
  {
    label: t("physicalRisk.menziesSection.headers.coastalFlooding"),
    attribute: "coastalFlooding"
  },
  {
    label: t("physicalRisk.menziesSection.headers.seaLevelRise"),
    attribute: "seaLevelRise"
  },
  {
    label: t("physicalRisk.menziesSection.headers.drought"),
    attribute: "drought"
  },
  {
    label: t("physicalRisk.menziesSection.headers.heatStress"),
    attribute: "heatStress"
  },
  {
    label: t("physicalRisk.menziesSection.headers.extremePrecipitation"),
    attribute: "extremePrecipitation"
  },
  {
    label: t("physicalRisk.menziesSection.headers.overallRisk"),
    attribute: "overallRisk"
  }
];